<template>
  <div class="custom-radio-container">
    <!-- 单选框组核心结构 -->
    <el-radio-group
      v-model="innerValue"
      :disabled="disabled"
      :size="size"
      @change="handleChange"
    >
      <!-- 遍历选项列表生成单选框 -->
      <el-radio
        v-for="item in options"
        :key="item.value"
        :label="item.value"
        :disabled="item.disabled || false"
        class="custom-radio-item"
      >
        <!-- 支持自定义选项文本，也可直接显示label -->
        <slot name="label" :item="item">
          {{ item.label }}
        </slot>
      </el-radio>
    </el-radio-group>
  </div>
</template>

<script>
export default {
  name: "CustomRadio",
  // 接收父组件传参
  props: {
    // 绑定值（v-model 对应的变量）
    value: {
      type: [String, Number, Boolean],
      required: true,
    },
    // 单选框选项列表，格式：[{ label: '文本', value: '值', disabled: false }]
    options: {
      type: Array,
      required: true,
      // 校验选项格式
      validator(val) {
        return val.every((item) => {
          return "label" in item && "value" in item;
        });
      },
    },
    // 是否禁用整个单选框组
    disabled: {
      type: Boolean,
      default: false,
    },
    // 尺寸：medium / small / mini
    size: {
      type: String,
      default: "medium",
      validator(val) {
        return ["medium", "small", "mini"].includes(val);
      },
    },
  },
  data() {
    return {
      // 内部值，用于双向绑定
      innerValue: this.value,
    };
  },
  watch: {
    // 监听父组件传值变化，同步到内部值
    value(newVal) {
      this.innerValue = newVal;
    },
    // 监听内部值变化，同步给父组件
    innerValue(newVal) {
      this.$emit("input", newVal);
    },
  },
  methods: {
    // 单选框切换事件，抛给父组件
    handleChange(val) {
      this.$emit("change", val);
    },
  },
};
</script>

<style scoped>
.custom-radio-container {
  /* 基础容器样式 */
  padding: 8px 0;
}

.custom-radio-item {
  /* 单选框选项间距 */
  margin-right: 20px;
  /* 可选：自定义选项字体大小 */
  font-size: 14px;
}

/* 禁用状态样式优化 */
:deep(.el-radio.is-disabled) {
  color: #999;
  cursor: not-allowed;
}
</style>
